import { FC } from 'react';
import { styled } from 'styled-components';
import { palette } from '@/constants/styles';

interface IFilterNumber {
	val: number;
}

const FilterNumber: FC<IFilterNumber> = ({ val }) => {
	return val === 0 ? null : <Number>{val}</Number>;
};

const Number = styled.div`
	margin-left: 0.2rem;
	color: ${palette.dangerColor};
`;

export default FilterNumber;
